import script from "./OcrTaxLinesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./OcrTaxLinesTable.vue?vue&type=script&setup=true&lang=ts"

import "./OcrTaxLinesTable.vue?vue&type=style&index=0&id=2bf3eae3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf3eae3"]])

export default __exports__